import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'

import LandingPage from "./LandingPage"
import AcademyPage from "./AcademyPage"
import AccountManagement from "./AccountManagement"
import Login from "./Auth/LogIn"
import Register from "./Auth/Register"
import ResetPassword from "./Auth/ResetPassword"
import ForgotPassword from './Auth/ForgotPassword'
import Success from './Auth/Success'
import About from "./About"
import Blank from "./Auth/blank"
import Webinar from "./Webinar"
import Inpersonreg from './Auth/Inpersonreg'

const routes = [
    { path: "/", exact: true, component: LandingPage },
    {
        path: "/academy",
        exact: true,
        component: AcademyPage
    },

    {
        path: "/register",
        exact: true,
        component: Register
    },

    {
        path: "/blank",
        exact: true,
        component: Blank
    },

    {
        path: "/account",
        exact: true,
        component: AccountManagement
    },

    {
        path: "/login",
        exact: true,
        component: Login
    },

    {
        path: "/reset",
        exact: true,
        component: ResetPassword
    },

    {
        path: "/forgot",
        exact: true,
        component: ForgotPassword
    },

    {
        path: "/about",
        exact: true,
        component: About
    },

    {
        path: "/webinar",
        exact: true,
        component: Webinar
    },

    {
        path: "/inpersonreg",
        exact: true,
        component: Inpersonreg
    },

    {
        path: "/success",
        exact: true,
        component: Success
    }
]

export default routes;